import { OgeTopicsResponse } from "@edu/shared";
import { call } from "../../../lib/api.ts";
import { isForeignTopics, type TopicSubject } from "./subject.ts";

/**
 * Справочник тем (4.1 docs/homework-phase2-design.md).
 *
 * ⚠️ Переехал сюда из `features/homework/assign/` 03.09.2026 вместе со
 * словарём предметов: справочник спрашивают уже два экрана, форма выдачи
 * домашки и комната урока.
 *
 * Живёт здесь, а не в `lib/api.ts`, по той же соседской причине, что ручка
 * карты покрытия: схема нужна ровно двум экранам, и класть её в общий модуль
 * значит тащить в каждый чанк, который этот модуль импортирует.
 *
 * ⚠️ Названия тем, уровни и потолки приезжают ДАННЫМИ, а не импортом из пакета:
 * реестр генераторов содержит правильные ответы и в бандл не попадает ни одним
 * путём (5.11 фазы 2), а словарь навыков в бандл технически может, но форма
 * живёт в стартовом чанке, и несколько килобайт словаря платил бы каждый, кто
 * открыл приложение.
 *
 * ⚠️ Справочник ПРЕДМЕТНЫЙ. Ручка одна, предметы различает параметром (раздел 7,
 * пункт 8 `docs/english-generators-design.md`), ответ кэшируется на час.
 *
 * ⚠️ У математики параметр НЕ шлётся, и это не забывчивость. Ручка отвечала
 * математикой ещё до появления параметра, и в браузерах живут вкладки со старым
 * бандлом, который спрашивает её ровно так; предмет по умолчанию обязан
 * остаться прежним, а значит запрос без параметра это честный запрос
 * математики, а не догадка о её будущем имени.
 *
 * ⚠️ Ответ ЧУЖОГО предмета это отказ загрузки, а не данные. Иначе при перекосе
 * версий (новый бандл против старого API в окно выкатки, откат API) старая
 * ручка отдала бы в английскую ветку математический справочник, преподаватель
 * набрал бы по нему строки, а отказ приехал бы только на раздаче и по строке на
 * каждого ученика. Здесь же это штатное «Темы по английскому не загрузились» с
 * кнопкой «Повторить».
 */
export async function getGeneratorTopics(subject: TopicSubject): Promise<OgeTopicsResponse> {
  const path =
    subject === "math"
      ? "/v1/homework/generator-topics"
      : `/v1/homework/generator-topics?subject=${encodeURIComponent(subject)}`;
  const res = await call(path, {}, OgeTopicsResponse);
  if (isForeignTopics(subject, res.subject)) {
    throw new Error(`справочник тем приехал чужого предмета: ${res.subject}`);
  }
  return res;
}
